import React from 'react';
import ArticleCard from './ArticleCard'; // Adjust path
import { commonStyles, layout, colors} from '../styles/minimalStyles';
import AnimateOnScroll from '../../Components/AnimateOnScroll';
const styles = {
  grid: {
    display: 'grid',
    gap: layout.gap,
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
     // Note: minmax(280px, 1fr) for smaller screens would require JS checks
  },
  noResults: {
    textAlign: 'center',
    padding: '30px',
    backgroundColor: colors.backgroundLight,
    border: `1px solid ${colors.border}`,
    borderRadius: '8px',
    color: colors.secondaryText,
  },
};

const ArticleGrid = ({ articles, onArticleClick, category }) => {
  return (
    <AnimateOnScroll> 
      <section style={{...commonStyles.container, ...commonStyles.section}}>
        <h2 style={commonStyles.sectionTitle}>More Articles</h2>
        {articles.length === 0 ? (
          <p style={styles.noResults}>
            No articles found{category !== 'All' ? ` in the "${category}" category` : ''}.
          </p>
        ) : (
          <div style={styles.grid}>
            {articles.map((article) => (
              <ArticleCard
                key={article.id}
                article={article}
                onClick={onArticleClick}
                layout="grid"
              />
            ))}
          </div>
        )}
        {/* Optional: Add Load More Button Here using Button component */}
      </section>
    </AnimateOnScroll>
  );
};

export default ArticleGrid;